import { Container } from '@pixi/react'
import { VoucherSelectPopup } from './selectPopup/VoucherSelectPopup'
import { VoucherHeader } from './header/VoucherHeader'
import { memo } from 'react'
import { VoucherTotalWinPopup } from './totalWinPopup/VoucherTotalWinPopup'

export const Voucher = memo(() => {
  return (
    <Container name="Voucher">
      <VoucherHeader />
      <VoucherSelectPopup />
      <VoucherTotalWinPopup />
    </Container>
  )
})
